<!--
 * @Author: Peng Bo Wei
 * @Date: 2021-10-25 18:40:54
 * @LastEditors: Peng Bo Wei
 * @LastEditTime: 2021-11-03 10:53:16
 * @Description: 
-->
<template>
  <div class="newAgency">
    <el-row class="newAgency-title">
      <el-col :span="24">
        <!-- <p class="text">{{dte}}年第{{quarter}}季度报告</p> -->
        <p class="text">{{ reportName }}</p>
      </el-col>
      <el-row class="steps-row">
        <el-steps :active="activeStep" align-center>
          <el-step
            :title="item"
            description
            v-for="(item, index) of stepArr"
            :key="item"
            @click.native="toStep(index)"
          ></el-step>
        </el-steps>
      </el-row>
    </el-row>

    <step-com
      :comArr="comArr"
      :myactiveStep="activeStep"
      @active="activeChange"
    ></step-com>
  </div>
</template>

<script>
import StepCom from "common/components/steps/stepItem";
const path = `QuaReport/components/com`;

export default {
  components: {
    StepCom,
  },

  data() {
    return {
      activeStep: 0,
      dte: "2019",
      quarter: "一",
      reportName: this.$route.query.reportName,
      stepArr: [],

      comArr: [
        `${path}/step1`,
        `${path}/step2`,
        `${path}/step3`,
        `${path}/step4`,
        `${path}/step5`,
        `${path}/step6`,
      ],
      fillType: "",
    };
  },
  mounted() {
    this.setConf();
  },
  methods: {
    setConf() {
      this.fillType = this.$route.query.reportFillType;
      console.log("getFillType using", this.fillType);
      if (this.fillType == "x") {
        this.stepArr = [
          "企业基本经营信息",
          "已发行产品情况",
          "年内拟发行产品情况",
          "企业重大变更事项及说明",
          "信息表上传",
          "完成提交",
        ];
      }
      if (this.fillType == "y") {
        this.stepArr = [
          "企业基本经营信息",
          "已投资项目情况",
          "年内拟完成项目投资情况",
          "企业重大变更事项及说明",
          "信息表上传",
          "完成提交",
        ];
      }
    },
    toStep(index) {
      if (index >= this.activeStep) return;
      else {
        this.$confirm(
          "请确定已编辑的内容已经保存,避免已填写数据丢失, 是否继续?",
          "提示",
          {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning",
          }
        )
          .then(() => {
            // this.returnBasic();
            this.activeStep = index;
          })
          .catch(() => {
            this.$message({
              type: "info",
              message: "已取消",
            });
          });
      }
    },
    activeChange(ev) {
      this.activeStep = ev;
    },
  },
};
</script>

<style lang="scss" scoped>
.newAgency {
  height: 100%;
  // overflow: auto;
  display: flex;
  flex-direction: column;
  &-title {
    height: 220px;
    background: #ffffff;
    border-radius: 4px;
    box-shadow: 0px 4px 12px 0px #cccccc80;
    padding: 20px;
    display: flex;
    flex: 0 0 auto;
    // overflow: auto;
    flex-direction: column;
    .steps-row {
      height: 100%;
      padding-bottom: 15px;
      display: flex;
      // overflow: auto;
      flex-direction: column;
      justify-content: flex-end;
    }
  }
}
::v-deep .userInfo {
  &::before {
    display: none;
  }
}
</style>
